<template>
    <div
        id="provider-level"
        class="flex w-full flex-col gap-4 rounded bg-white p-6 shadow"
    >
        <div class="font-semibold">Provider Level</div>

        <div class="">
            <form-select
                label="Provider Level"
                v-model="form.provider_level_id"
                :options="providerLevelOptions"
            ></form-select>
        </div>

        <div v-if="form.isDirty">
            <div class="-mt-2 mb-4 text-[14px]">
                <span class="font-semibold">
                    Changing your provider level will reset ALL your
                    progress.</span
                >
                This will remove all quiz, flashcard, study guide worksheet, and
                video history, reset all readiness progress and your study time.
            </div>

            <form-checkbox
                label="Yes, reset my progress and change my provider level"
                v-model="form.confirmed"
            />
        </div>

        <div class="flex justify-end">
            <div
                v-if="form.isDirty && form.confirmed"
                @click="save()"
                class="rounded bg-primary-525 px-2 py-3 text-white hover:cursor-pointer hover:bg-primary-625"
            >
                Change Provider Level
            </div>
            <div
                v-else
                class="rounded bg-primary-525 px-2 py-3 text-white opacity-50 hover:cursor-not-allowed"
            >
                Change Provider Level
            </div>
        </div>
    </div>
</template>
<script>
import FormSelect from "@/Components/FormSelect.vue";
import FormCheckbox from "@/Components/FormCheckbox.vue";

export default {
    name: "StudentChangeProviderLevelForm",
    components: {
        FormSelect,
        FormCheckbox,
    },
    props: {
        user: {},
    },
    data() {
        return {
            form: this.$inertia.form({
                provider_level_id: this.user.provider_level_id,
                confirmed: false,
            }),
        };
    },
    methods: {
        save() {
            let vm = this;


            this.$inertia.get(
                route("student.account.change-provider-level"),
                vm.form
            );
        },
    },
    computed: {
        providerLevelOptions() {
            let providerLevelOptions = [];

            this.$page.props.providerLevels.forEach(function (providerLevel) {
                providerLevelOptions.push({
                    value: providerLevel.id,
                    label: providerLevel.title,
                });
            });

            return providerLevelOptions;
        },
    },
};
</script>
